export default __webpack_public_path__ + "static/media/testimonial02.ebdb30ba.jpg";